import http from '../../http';
import { AuthResource } from '../entities';
import { BasicAuth, JsonApiResponse } from '../interfaces';

const resource = 'auth';

const setAuth = (auth: BasicAuth) => {
  // http.defaults.auth = { username: auth.user, password: auth.pass };
};

/**
 * Returns an authentication resource if authenticated.
 */
const get = async (): Promise<AuthResource> => {
  const response = await http.get<JsonApiResponse<AuthResource>>(
    `/${resource}`,
  );
  return response.data.data;
};

const post = async (auth: BasicAuth): Promise<AuthResource> => {
  const response = await http.post<JsonApiResponse<AuthResource>>(
    `/${resource}`,
    { username: auth.user, password: auth.pass },
  );
  return response.data.data;
};

const AuthDataService = {
  get,
  setAuth,
  post,
};

export default AuthDataService;
